document.addEventListener('DOMContentLoaded', function () {
  var RESTRICTED = ['pro shop', 'arms shop', 'shooting range']; // match nav text
  var modal = document.getElementById('AgeGateModal');
  if (!modal) return;

  var overlay = document.getElementById('AgeGateOverlay');
  var yesBtn = document.getElementById('AgeGateYes');
  var noBtn = document.getElementById('AgeGateNo');
  var pendingUrl = null;

  function show(url) {
    pendingUrl = url;
    modal.classList.remove('x-hidden');
    document.body.classList.add('overflow-hidden');
  }

  function hide() {
    modal.classList.add('x-hidden');
    document.body.classList.remove('overflow-hidden');
    pendingUrl = null;
  }

  function matches(text) {
    var t = (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return RESTRICTED.indexOf(t) !== -1;
  }

  document.addEventListener('click', function (e) {
    if (modal.contains(e.target)) return;

    var link = e.target.closest('a[href]');
    if (!link) return;

    if (matches(link.textContent)) {
      e.preventDefault();
      e.stopPropagation();
      show(link.href);
    }
  }, true);

  yesBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    var url = pendingUrl;
    hide();
    if (url) window.location.href = url;
  });

  noBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    hide();
  });

  overlay.addEventListener('click', function (e) {
    e.stopPropagation();
    hide();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.classList.contains('x-hidden')) hide();
  });
});
